import axios from "axios"

export const ReportService = () => {
  const refreshIlliquidReport = async (year, month, token) => {
    await axios.post(
      `${process.env.REACT_APP_TERA_ETL}/illiquid-report/refresh/${year}/${month}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
  }

  return { refreshIlliquidReport }
}
